import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaDownload, FaAndroid, FaTimes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export default function FloatingCTA() {
  const { t } = useTranslation();
  const [showPopup, setShowPopup] = useState(false);
  const [showMain, setShowMain] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowMain(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Main Floating Button */}
      <AnimatePresence>
        {showMain && (
          <motion.div
            initial={{ scale: 0, rotate: -180 }}
            animate={{ scale: 1, rotate: 0 }}
            exit={{ scale: 0 }}
            className="fixed bottom-24 right-6 z-50"
          >
            <motion.button
              onClick={() => setShowPopup(true)}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              animate={{
                boxShadow: ['0 0 20px #4CAF50', '0 0 40px #4CAF50', '0 0 20px #4CAF50']
              }}
              transition={{ repeat: Infinity, duration: 2 }}
              className="w-16 h-16 rounded-full bg-gradient-to-r from-green-500 to-emerald-600 flex items-center justify-center shadow-2xl"
            >
              <FaDownload className="text-white text-2xl animate-bounce" />
            </motion.button>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Download Popup */}
      <AnimatePresence>
        {showPopup && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[70] flex items-center justify-center p-4"
            onClick={() => setShowPopup(false)}
          >
            <motion.div
              initial={{ scale: 0.5, y: 100 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.5, y: 100 }}
              onClick={(e) => e.stopPropagation()}
              className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-3xl p-8 max-w-md w-full text-center relative overflow-hidden"
            >
              <button onClick={() => setShowPopup(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white">
                <FaTimes size={20} />
              </button>

              <div className="absolute -top-10 -right-10 w-32 h-32 bg-green-500/20 rounded-full blur-3xl" />
              <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-yellow-500/20 rounded-full blur-3xl" />

              <motion.div
                animate={{ rotate: [0, 10, -10, 0] }}
                transition={{ repeat: Infinity, duration: 3 }}
                className="text-7xl mb-4"
              >
                💰
              </motion.div>

              <h2 className="text-3xl font-black text-white mb-2">
                {t('floatingCTA.title')}
              </h2>
              <p className="text-gray-400 mb-6">{t('floatingCTA.subtitle')}</p>

              <a
                href="https://drive.google.com/file/d/18UrcDjcOR2e1GvaFQW7UuYSLIjJUpcqH/view"
                target="_blank"
                rel="noopener noreferrer"
              >
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="w-full py-4 bg-gradient-to-r from-green-500 to-emerald-600 rounded-2xl font-bold text-white text-lg flex items-center justify-center gap-2 mb-3"
                >
                  <FaAndroid size={24} />
                  {t('floatingCTA.button')}
                </motion.button>
              </a>
              <p className="text-gray-500 text-xs">{t('floatingCTA.version')}</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}







// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { FaDownload, FaAndroid, FaTimes } from 'react-icons/fa';

// export default function FloatingCTA() {
//   const [showPopup, setShowPopup] = useState(false);
//   const [showMain, setShowMain] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => setShowMain(true), 5000);
//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <>
//       {/* Main Floating Button */}
//       <AnimatePresence>
//         {showMain && (
//           <motion.div
//             initial={{ scale: 0, rotate: -180 }}
//             animate={{ scale: 1, rotate: 0 }}
//             exit={{ scale: 0 }}
//             className="fixed bottom-24 right-6 z-50"
//           >
//             <motion.button
//               onClick={() => setShowPopup(true)}
//               whileHover={{ scale: 1.1 }}
//               whileTap={{ scale: 0.9 }}
//               animate={{
//                 boxShadow: ['0 0 20px #4CAF50', '0 0 40px #4CAF50', '0 0 20px #4CAF50']
//               }}
//               transition={{ repeat: Infinity, duration: 2 }}
//               className="w-16 h-16 rounded-full bg-gradient-to-r from-green-500 to-emerald-600 flex items-center justify-center shadow-2xl"
//             >
//               <FaDownload className="text-white text-2xl animate-bounce" />
//             </motion.button>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Download Popup */}
//       <AnimatePresence>
//         {showPopup && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[70] flex items-center justify-center p-4"
//             onClick={() => setShowPopup(false)}
//           >
//             <motion.div
//               initial={{ scale: 0.5, y: 100 }}
//               animate={{ scale: 1, y: 0 }}
//               exit={{ scale: 0.5, y: 100 }}
//               onClick={(e) => e.stopPropagation()}
//               className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-3xl p-8 max-w-md w-full text-center relative overflow-hidden"
//             >
//               <button onClick={() => setShowPopup(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white">
//                 <FaTimes size={20} />
//               </button>

//               <div className="absolute -top-10 -right-10 w-32 h-32 bg-green-500/20 rounded-full blur-3xl" />
//               <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-yellow-500/20 rounded-full blur-3xl" />

//               <motion.div
//                 animate={{ rotate: [0, 10, -10, 0] }}
//                 transition={{ repeat: Infinity, duration: 3 }}
//                 className="text-7xl mb-4"
//               >
//                 💰
//               </motion.div>

//               <h2 className="text-3xl font-black text-white mb-2">
//                 Get <span className="text-green-400">₹50 Bonus</span>!
//               </h2>
//               <p className="text-gray-400 mb-6">Download now and start winning</p>

//               <a
//                 href="https://drive.google.com/file/d/18UrcDjcOR2e1GvaFQW7UuYSLIjJUpcqH/view"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <motion.button
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                   className="w-full py-4 bg-gradient-to-r from-green-500 to-emerald-600 rounded-2xl font-bold text-white text-lg flex items-center justify-center gap-2 mb-3"
//                 >
//                   <FaAndroid size={24} />
//                   Download for Android
//                 </motion.button>
//               </a>
//               <p className="text-gray-500 text-xs">Version 1.0.0 • 45 MB • Free</p>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </>
//   );
// }